import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { fetchUserComments } from "../../../../actions/mine_craft/commentsActions";
import { queryParams } from "../../../../helpers/UrlHelpers";

import Pagination from "../../../../componets/Pagination";
import Card from "../../../../componets/Card";
import CommentsList from "../../Comments/_partials/_List";

const LIMIT = 20;

const _SentComments = ({ userId }: { userId: number | undefined }) => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const count           = useAppSelector(state => state.mineCraft.comments.count);

  useEffect(() => {
    if (!userId) {
      return;
    }

    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT
    };

    dispatch(fetchUserComments({ userId, params }))
  }, [userId, currentPage, dispatch]);

  return (
    <Card>
      <h4 className='v-content-title'>Comments</h4>
      <CommentsList />

      <Pagination total={count} size={LIMIT} />
    </Card>
  )
}

export default _SentComments;
